export const defaultLanguage = "ko"

export const languageOptions = [
  { code: "ko", label: "한국어" },
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
]

export const translations = {
  ko: {
    nav: {
      home: "홈",
      about: "회사소개",
      services: "서비스",
      contact: "문의하기",
      menuToggle: "메뉴 토글",
      languageAriaLabel: "언어 선택",
    },
    hero: {
      title: "코드그로브",
      subtitle:
        "미래를 선도할 개발 전문가를 양성하고, 고객에게 최적의 제품 솔루션을 제공하는 프로그래밍 전문 기업입니다.",
      cta: "상담 신청하기",
    },
    about: {
      sectionTitle: "코드그로브 소개",
      sectionSubtitle:
        "실무 중심의 코딩 교육과 프로젝트 경험으로 미래의 개발자를 양성합니다",
      achievementLabels: ["교육 수료생", "기업 교육 진행", "프로젝트 수행"],
      bannerAlt: "코드그로브 팀",
      introTitle: "강의 & 코딩 교육 전문",
      introParagraph1:
        "코드그로브는 실무 프로젝트 기반의 코딩 교육을 전문으로 합니다. 현업에서 직접 경험한 개발 노하우를 바탕으로, 취업 준비생부터 현직 개발자까지 맞춤형 교육을 제공합니다.",
      introParagraph2:
        "Python, JavaScript, React, Flutter 등 최신 기술 스택과 함께 AI/LLM 활용 개발까지, 시장에서 필요로 하는 실전 역량을 키울 수 있습니다. 단순 이론이 아닌, 실제 서비스를 만들어보는 프로젝트 중심 커리큘럼으로 진행됩니다.",
      educationPoints: [
        "기업 맞춤형 개발자 양성 교육",
        "취업 연계 부트캠프 프로그램",
        "현직 개발자 스킬업 과정",
        "AI/LLM 활용 개발 특화 교육",
      ],
      mandu: {
        title: "만두쌤의 코딩 한 꼬집",
        mobileSubtitle: "웹/모바일 개발 학습 플랫폼",
        desktopSubtitle: "웹/모바일 개발 통합 학습 플랫폼",
        features: ["학습 콘텐츠", "AI 질문", "스터디 스페이스"],
        visit: "방문하기",
        logoAlt: "만두쌤 로고",
      },
      projectsTitle: "주요 프로젝트 실적",
      projects: [
        {
          company: "A사 (대기업 통신사)",
          description: "웹 서비스 플랫폼 개발 및 AI 기반 고객 관리 시스템 구축",
        },
        {
          company: "B사 (교육 기관)",
          description:
            "프로그래밍 LMS 시스템 개발 및 실시간 코딩 교육 플랫폼 구축",
        },
        {
          company: "C사 (핀테크)",
          description:
            "Flutter 기반 크로스 플랫폼 모바일 앱 및 트레이딩 시스템 개발",
        },
      ],
    },
    services: {
      sectionTitle: "주요 사업 분야",
      items: [
        {
          title: "전문 개발 교육",
          description:
            "실무 중심의 커리큘럼과 현업 전문가의 지도로 차세대 개발자를 양성합니다.",
        },
        {
          title: "웹 서비스 개발",
          description:
            "최신 기술을 활용하여 안정적이고 확장 가능한 맞춤형 웹 서비스를 구축합니다.",
        },
        {
          title: "앱 개발",
          description:
            "iOS 및 Android 플랫폼을 위한 사용자 친화적인 고성능 모바일 앱을 개발합니다.",
        },
        {
          title: "LLM 애플리케이션",
          description:
            "OpenAI, Claude 등 LLM을 활용한 맞춤형 비즈니스 애플리케이션을 개발합니다.",
        },
      ],
    },
    contact: {
      title: "문의하기",
      description:
        "프로젝트 문의나 교육 상담이 필요하시면 언제든지 연락주세요. 최선을 다해 답변드리겠습니다.",
      address: "서울시 강동구 동남로71길",
      labels: {
        name: "이름",
        email: "이메일",
        message: "메시지",
      },
      submit: {
        idle: "메시지 보내기",
        loading: "전송 중...",
      },
      success: "메시지가 성공적으로 전송되었습니다!",
      errors: {
        required: "모든 필드를 입력해주세요.",
        invalidEmail: "유효한 이메일 주소를 입력해주세요.",
        submit: "메시지 전송 중 오류가 발생했습니다.",
        network: "네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
      },
    },
    footer: {
      rights: "모든 권리 보유.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact",
      menuToggle: "Toggle menu",
      languageAriaLabel: "Select language",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "We train future-ready software professionals and deliver optimized product solutions for our clients.",
      cta: "Request Consultation",
    },
    about: {
      sectionTitle: "About Codegrove",
      sectionSubtitle:
        "We nurture future developers through practical coding education and real project experience.",
      achievementLabels: [
        "Program Graduates",
        "Corporate Training Programs",
        "Projects Delivered",
      ],
      bannerAlt: "Codegrove team",
      introTitle: "Specialists in Lectures & Coding Education",
      introParagraph1:
        "Codegrove specializes in project-based coding education for real-world practice. Based on firsthand industry experience, we provide tailored programs for job seekers and working developers alike.",
      introParagraph2:
        "From modern stacks like Python, JavaScript, React, and Flutter to AI/LLM-enabled development, we help learners build practical skills demanded by the market through hands-on, project-focused curricula.",
      educationPoints: [
        "Customized developer training for companies",
        "Job-linked bootcamp programs",
        "Upskilling courses for working developers",
        "AI/LLM-focused development training",
      ],
      mandu: {
        title: "Mandu Teacher's Coding Bite",
        mobileSubtitle: "Web/Mobile Development Learning Platform",
        desktopSubtitle: "Integrated Web/Mobile Development Learning Platform",
        features: ["Learning Content", "AI Q&A", "Study Space"],
        visit: "Visit",
        logoAlt: "Mandu logo",
      },
      projectsTitle: "Key Project Portfolio",
      projects: [
        {
          company: "Company A (Major Telecom Enterprise)",
          description:
            "Developed a web service platform and built an AI-based customer management system.",
        },
        {
          company: "Company B (Education Provider)",
          description:
            "Built a programming LMS and a real-time coding education platform.",
        },
        {
          company: "Company C (Fintech)",
          description:
            "Developed a Flutter-based cross-platform mobile app and trading system.",
        },
      ],
    },
    services: {
      sectionTitle: "Core Business Areas",
      items: [
        {
          title: "Professional Developer Training",
          description:
            "We cultivate next-generation developers with practical curricula and guidance from industry experts.",
        },
        {
          title: "Web Service Development",
          description:
            "We build stable, scalable, and customized web services with modern technologies.",
        },
        {
          title: "App Development",
          description:
            "We create user-friendly, high-performance mobile apps for iOS and Android.",
        },
        {
          title: "LLM Applications",
          description:
            "We develop tailored business applications powered by LLMs like OpenAI and Claude.",
        },
      ],
    },
    contact: {
      title: "Contact Us",
      description:
        "If you need project support or training consultation, feel free to reach out anytime.",
      address: "Dongnam-ro 71-gil, Gangdong-gu, Seoul, South Korea",
      labels: {
        name: "Name",
        email: "Email",
        message: "Message",
      },
      submit: {
        idle: "Send Message",
        loading: "Sending...",
      },
      success: "Your message has been sent successfully!",
      errors: {
        required: "Please fill in all fields.",
        invalidEmail: "Please enter a valid email address.",
        submit: "An error occurred while sending your message.",
        network: "A network error occurred. Please try again later.",
      },
    },
    footer: {
      rights: "All rights reserved.",
    },
  },
  zh: {
    nav: {
      home: "首页",
      about: "公司介绍",
      services: "服务",
      contact: "联系我们",
      menuToggle: "切换菜单",
      languageAriaLabel: "选择语言",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "我们培养面向未来的软件开发人才，并为客户提供最优产品解决方案。",
      cta: "申请咨询",
    },
    about: {
      sectionTitle: "关于 Codegrove",
      sectionSubtitle: "通过实战型编程教育和项目经验培养未来开发者。",
      achievementLabels: ["教育结业学员", "企业培训项目", "项目交付"],
      bannerAlt: "Codegrove 团队",
      introTitle: "专注授课与编程教育",
      introParagraph1:
        "Codegrove 专注于基于实战项目的编程教育。依托一线开发经验，为求职者和在职开发者提供定制化课程。",
      introParagraph2:
        "从 Python、JavaScript、React、Flutter 等现代技术栈到 AI/LLM 应用开发，我们通过项目导向课程帮助学员提升市场所需的实战能力。",
      educationPoints: [
        "企业定制开发者培养课程",
        "就业衔接训练营项目",
        "在职开发者技能提升课程",
        "AI/LLM 应用开发专项课程",
      ],
      mandu: {
        title: "Mandu 老师编程小课堂",
        mobileSubtitle: "Web/移动开发学习平台",
        desktopSubtitle: "Web/移动开发一体化学习平台",
        features: ["学习内容", "AI 问答", "学习空间"],
        visit: "访问",
        logoAlt: "Mandu 标志",
      },
      projectsTitle: "主要项目业绩",
      projects: [
        {
          company: "A 公司（大型通信企业）",
          description: "开发 Web 服务平台并构建 AI 客户管理系统。",
        },
        {
          company: "B 公司（教育机构）",
          description: "开发编程 LMS 系统与实时编码教学平台。",
        },
        {
          company: "C 公司（金融科技）",
          description:
            "开发基于 Flutter 的跨平台移动应用与交易系统。",
        },
      ],
    },
    services: {
      sectionTitle: "核心业务领域",
      items: [
        {
          title: "专业开发教育",
          description: "以实务课程和行业专家指导培养下一代开发者。",
        },
        {
          title: "Web 服务开发",
          description: "利用现代技术构建稳定、可扩展的定制化 Web 服务。",
        },
        {
          title: "应用开发",
          description: "为 iOS 与 Android 打造高性能、易用的移动应用。",
        },
        {
          title: "LLM 应用",
          description:
            "基于 OpenAI、Claude 等 LLM 开发定制化商业应用。",
        },
      ],
    },
    contact: {
      title: "联系我们",
      description: "如需项目咨询或培训咨询，欢迎随时联系。",
      address: "韩国首尔市江东区东南路71街",
      labels: {
        name: "姓名",
        email: "邮箱",
        message: "留言",
      },
      submit: {
        idle: "发送留言",
        loading: "发送中...",
      },
      success: "您的留言已成功发送！",
      errors: {
        required: "请填写所有字段。",
        invalidEmail: "请输入有效的邮箱地址。",
        submit: "发送留言时发生错误。",
        network: "发生网络错误，请稍后再试。",
      },
    },
    footer: {
      rights: "保留所有权利。",
    },
  },
  ja: {
    nav: {
      home: "ホーム",
      about: "会社紹介",
      services: "サービス",
      contact: "お問い合わせ",
      menuToggle: "メニュー切替",
      languageAriaLabel: "言語を選択",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "未来を先導する開発人材を育成し、お客様に最適なプロダクトソリューションを提供します。",
      cta: "相談を申し込む",
    },
    about: {
      sectionTitle: "Codegrove について",
      sectionSubtitle:
        "実務中心のコーディング教育とプロジェクト経験で未来の開発者を育成します。",
      achievementLabels: ["修了生", "企業研修実施", "プロジェクト実績"],
      bannerAlt: "Codegrove チーム",
      introTitle: "講義・コーディング教育の専門家",
      introParagraph1:
        "Codegrove は実務プロジェクトベースのコーディング教育を専門としています。現場経験に基づき、就職準備中の方から現役開発者まで最適な教育を提供します。",
      introParagraph2:
        "Python、JavaScript、React、Flutter などの最新技術スタックに加え、AI/LLM 活用開発まで、市場で求められる実践力をプロジェクト中心カリキュラムで身につけられます。",
      educationPoints: [
        "企業向けカスタム開発者育成研修",
        "就職連携ブートキャンププログラム",
        "現役開発者向けスキルアップコース",
        "AI/LLM 活用開発特化教育",
      ],
      mandu: {
        title: "Mandu先生のコーディングひとつまみ",
        mobileSubtitle: "Web/モバイル開発学習プラットフォーム",
        desktopSubtitle: "Web/モバイル開発統合学習プラットフォーム",
        features: ["学習コンテンツ", "AI 質問", "スタディスペース"],
        visit: "アクセス",
        logoAlt: "Mandu ロゴ",
      },
      projectsTitle: "主要プロジェクト実績",
      projects: [
        {
          company: "A社（大手通信企業）",
          description:
            "Webサービスプラットフォーム開発およびAI顧客管理システムを構築。",
        },
        {
          company: "B社（教育機関）",
          description:
            "プログラミングLMSシステムとリアルタイムコーディング教育プラットフォームを開発。",
        },
        {
          company: "C社（フィンテック）",
          description:
            "Flutterベースのクロスプラットフォームモバイルアプリと取引システムを開発。",
        },
      ],
    },
    services: {
      sectionTitle: "主要事業分野",
      items: [
        {
          title: "専門開発教育",
          description:
            "実務中心カリキュラムと現場専門家の指導で次世代開発者を育成します。",
        },
        {
          title: "Webサービス開発",
          description:
            "最新技術で安定かつ拡張可能なカスタムWebサービスを構築します。",
        },
        {
          title: "アプリ開発",
          description:
            "iOS・Android向けの使いやすく高性能なモバイルアプリを開発します。",
        },
        {
          title: "LLMアプリケーション",
          description:
            "OpenAI、Claude などのLLMを活用した業務向けアプリを開発します。",
        },
      ],
    },
    contact: {
      title: "お問い合わせ",
      description:
        "プロジェクト相談や教育相談が必要な場合は、いつでもご連絡ください。",
      address: "韓国 ソウル特別市 江東区 東南路71ギル",
      labels: {
        name: "お名前",
        email: "メール",
        message: "メッセージ",
      },
      submit: {
        idle: "メッセージを送信",
        loading: "送信中...",
      },
      success: "メッセージが正常に送信されました！",
      errors: {
        required: "すべての項目を入力してください。",
        invalidEmail: "有効なメールアドレスを入力してください。",
        submit: "メッセージ送信中にエラーが発生しました。",
        network: "ネットワークエラーが発生しました。しばらくしてから再試行してください。",
      },
    },
    footer: {
      rights: "All rights reserved.",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      contact: "Contact",
      menuToggle: "Basculer le menu",
      languageAriaLabel: "Choisir la langue",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "Nous formons des experts du développement orientés vers l'avenir et fournissons des solutions produit optimales à nos clients.",
      cta: "Demander une consultation",
    },
    about: {
      sectionTitle: "À propos de Codegrove",
      sectionSubtitle:
        "Nous formons les développeurs de demain grâce à une éducation pratique et des projets concrets.",
      achievementLabels: [
        "Diplômés formés",
        "Formations en entreprise",
        "Projets réalisés",
      ],
      bannerAlt: "Équipe Codegrove",
      introTitle: "Spécialistes des cours et de la formation au code",
      introParagraph1:
        "Codegrove est spécialisé dans la formation au code basée sur des projets réels. Grâce à notre expérience terrain, nous proposons des parcours adaptés aux chercheurs d'emploi comme aux développeurs en activité.",
      introParagraph2:
        "Des stacks modernes comme Python, JavaScript, React et Flutter au développement basé sur l'IA/LLM, nous renforçons les compétences pratiques attendues par le marché via des parcours orientés projet.",
      educationPoints: [
        "Formation développeur sur mesure pour les entreprises",
        "Bootcamps liés à l'emploi",
        "Parcours de montée en compétences pour développeurs",
        "Formation spécialisée IA/LLM",
      ],
      mandu: {
        title: "Une pincée de code avec Professeur Mandu",
        mobileSubtitle: "Plateforme d'apprentissage Web/Mobile",
        desktopSubtitle:
          "Plateforme intégrée d'apprentissage du développement Web/Mobile",
        features: ["Contenu d'apprentissage", "Questions IA", "Espace d'étude"],
        visit: "Visiter",
        logoAlt: "Logo Mandu",
      },
      projectsTitle: "Projets majeurs",
      projects: [
        {
          company: "Entreprise A (Grand opérateur télécom)",
          description:
            "Développement d'une plateforme web et mise en place d'un système de gestion client basé sur l'IA.",
        },
        {
          company: "Entreprise B (Établissement éducatif)",
          description:
            "Développement d'un LMS de programmation et d'une plateforme de codage en temps réel.",
        },
        {
          company: "Entreprise C (Fintech)",
          description:
            "Développement d'une application mobile cross-platform sous Flutter et d'un système de trading.",
        },
      ],
    },
    services: {
      sectionTitle: "Domaines d'activité principaux",
      items: [
        {
          title: "Formation développeur professionnelle",
          description:
            "Nous formons la nouvelle génération de développeurs avec des programmes pratiques guidés par des experts terrain.",
        },
        {
          title: "Développement de services web",
          description:
            "Nous créons des services web sur mesure, stables et évolutifs, avec des technologies modernes.",
        },
        {
          title: "Développement d'applications",
          description:
            "Nous développons des applications mobiles performantes et intuitives pour iOS et Android.",
        },
        {
          title: "Applications LLM",
          description:
            "Nous développons des applications métier personnalisées basées sur des LLM comme OpenAI et Claude.",
        },
      ],
    },
    contact: {
      title: "Contactez-nous",
      description:
        "Pour toute demande de projet ou de formation, n'hésitez pas à nous contacter.",
      address: "Dongnam-ro 71-gil, Gangdong-gu, Séoul, Corée du Sud",
      labels: {
        name: "Nom",
        email: "E-mail",
        message: "Message",
      },
      submit: {
        idle: "Envoyer le message",
        loading: "Envoi en cours...",
      },
      success: "Votre message a été envoyé avec succès !",
      errors: {
        required: "Veuillez remplir tous les champs.",
        invalidEmail: "Veuillez saisir une adresse e-mail valide.",
        submit: "Une erreur est survenue lors de l'envoi du message.",
        network: "Une erreur réseau est survenue. Veuillez réessayer plus tard.",
      },
    },
    footer: {
      rights: "Tous droits réservés.",
    },
  },
  de: {
    nav: {
      home: "Start",
      about: "Über uns",
      services: "Leistungen",
      contact: "Kontakt",
      menuToggle: "Menü umschalten",
      languageAriaLabel: "Sprache auswählen",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "Wir bilden zukunftsorientierte Entwicklungsexperten aus und liefern unseren Kunden optimale Produktlösungen.",
      cta: "Beratung anfragen",
    },
    about: {
      sectionTitle: "Über Codegrove",
      sectionSubtitle:
        "Wir fördern zukünftige Entwickler durch praxisnahe Programmierausbildung und Projektarbeit.",
      achievementLabels: [
        "Absolventen",
        "Unternehmensschulungen",
        "Umgesetzte Projekte",
      ],
      bannerAlt: "Codegrove Team",
      introTitle: "Spezialist für Unterricht & Coding-Ausbildung",
      introParagraph1:
        "Codegrove ist auf projektbasierte Coding-Ausbildung mit Praxisbezug spezialisiert. Auf Basis realer Branchenerfahrung bieten wir passgenaue Programme für Berufseinsteiger und aktive Entwickler.",
      introParagraph2:
        "Von modernen Stacks wie Python, JavaScript, React und Flutter bis hin zur AI/LLM-gestützten Entwicklung vermitteln wir marktrelevante Praxiskompetenzen durch projektorientierte Curricula.",
      educationPoints: [
        "Maßgeschneiderte Entwicklerausbildung für Unternehmen",
        "Berufsorientierte Bootcamp-Programme",
        "Upskilling-Kurse für aktive Entwickler",
        "Spezialisierte AI/LLM-Entwicklungsausbildung",
      ],
      mandu: {
        title: "Eine Prise Coding mit Lehrer Mandu",
        mobileSubtitle: "Lernplattform für Web-/Mobile-Entwicklung",
        desktopSubtitle:
          "Integrierte Lernplattform für Web-/Mobile-Entwicklung",
        features: ["Lerninhalte", "AI-Fragen", "Study Space"],
        visit: "Besuchen",
        logoAlt: "Mandu Logo",
      },
      projectsTitle: "Wichtige Projektreferenzen",
      projects: [
        {
          company: "Unternehmen A (Großer Telekom-Konzern)",
          description:
            "Entwicklung einer Web-Service-Plattform und Aufbau eines AI-basierten Kundenmanagementsystems.",
        },
        {
          company: "Unternehmen B (Bildungseinrichtung)",
          description:
            "Entwicklung eines Programmier-LMS und einer Echtzeit-Coding-Lernplattform.",
        },
        {
          company: "Unternehmen C (FinTech)",
          description:
            "Entwicklung einer Flutter-basierten Cross-Platform-Mobile-App und eines Trading-Systems.",
        },
      ],
    },
    services: {
      sectionTitle: "Kernbereiche",
      items: [
        {
          title: "Professionelle Entwicklerausbildung",
          description:
            "Wir bilden die nächste Generation von Entwicklern mit praxisnahen Curricula und Expertenbetreuung aus.",
        },
        {
          title: "Web-Service-Entwicklung",
          description:
            "Wir entwickeln stabile, skalierbare und maßgeschneiderte Web-Services mit modernen Technologien.",
        },
        {
          title: "App-Entwicklung",
          description:
            "Wir entwickeln benutzerfreundliche, leistungsstarke Mobile-Apps für iOS und Android.",
        },
        {
          title: "LLM-Anwendungen",
          description:
            "Wir entwickeln individuelle Business-Anwendungen auf Basis von LLMs wie OpenAI und Claude.",
        },
      ],
    },
    contact: {
      title: "Kontakt",
      description:
        "Wenn Sie Projektunterstützung oder Schulungsberatung benötigen, kontaktieren Sie uns jederzeit.",
      address: "Dongnam-ro 71-gil, Gangdong-gu, Seoul, Südkorea",
      labels: {
        name: "Name",
        email: "E-Mail",
        message: "Nachricht",
      },
      submit: {
        idle: "Nachricht senden",
        loading: "Wird gesendet...",
      },
      success: "Ihre Nachricht wurde erfolgreich gesendet!",
      errors: {
        required: "Bitte füllen Sie alle Felder aus.",
        invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        submit: "Beim Senden der Nachricht ist ein Fehler aufgetreten.",
        network:
          "Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
      },
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      contact: "Contacto",
      menuToggle: "Alternar menú",
      languageAriaLabel: "Seleccionar idioma",
    },
    hero: {
      title: "Codegrove",
      subtitle:
        "Formamos profesionales de desarrollo con visión de futuro y ofrecemos soluciones de producto optimizadas para nuestros clientes.",
      cta: "Solicitar consulta",
    },
    about: {
      sectionTitle: "Sobre Codegrove",
      sectionSubtitle:
        "Formamos a los desarrolladores del futuro mediante educación práctica en programación y experiencia en proyectos reales.",
      achievementLabels: [
        "Graduados formados",
        "Capacitaciones corporativas",
        "Proyectos ejecutados",
      ],
      bannerAlt: "Equipo de Codegrove",
      introTitle: "Especialistas en clases y formación en programación",
      introParagraph1:
        "Codegrove se especializa en educación en programación basada en proyectos reales. Con experiencia directa de la industria, ofrecemos formación personalizada para quienes buscan empleo y para desarrolladores en activo.",
      introParagraph2:
        "Desde stacks modernos como Python, JavaScript, React y Flutter hasta desarrollo con AI/LLM, fortalecemos habilidades prácticas demandadas por el mercado mediante un currículo centrado en proyectos.",
      educationPoints: [
        "Formación de desarrolladores a medida para empresas",
        "Programas bootcamp vinculados al empleo",
        "Cursos de mejora para desarrolladores en activo",
        "Formación especializada en desarrollo con AI/LLM",
      ],
      mandu: {
        title: "Una pizca de código con el profesor Mandu",
        mobileSubtitle: "Plataforma de aprendizaje de desarrollo web/móvil",
        desktopSubtitle:
          "Plataforma integral de aprendizaje de desarrollo web/móvil",
        features: [
          "Contenido de aprendizaje",
          "Preguntas a IA",
          "Espacio de estudio",
        ],
        visit: "Visitar",
        logoAlt: "Logo de Mandu",
      },
      projectsTitle: "Proyectos destacados",
      projects: [
        {
          company: "Empresa A (Gran empresa de telecomunicaciones)",
          description:
            "Desarrollo de plataforma de servicios web y construcción de sistema de gestión de clientes basado en IA.",
        },
        {
          company: "Empresa B (Institución educativa)",
          description:
            "Desarrollo de sistema LMS de programación y plataforma de enseñanza de código en tiempo real.",
        },
        {
          company: "Empresa C (Fintech)",
          description:
            "Desarrollo de app móvil multiplataforma basada en Flutter y sistema de trading.",
        },
      ],
    },
    services: {
      sectionTitle: "Áreas principales del negocio",
      items: [
        {
          title: "Formación profesional de desarrolladores",
          description:
            "Formamos a la próxima generación de desarrolladores con currículos prácticos y guía de expertos del sector.",
        },
        {
          title: "Desarrollo de servicios web",
          description:
            "Construimos servicios web personalizados, estables y escalables con tecnologías modernas.",
        },
        {
          title: "Desarrollo de apps",
          description:
            "Desarrollamos apps móviles de alto rendimiento y fáciles de usar para iOS y Android.",
        },
        {
          title: "Aplicaciones LLM",
          description:
            "Desarrollamos aplicaciones de negocio personalizadas con LLM como OpenAI y Claude.",
        },
      ],
    },
    contact: {
      title: "Contáctanos",
      description:
        "Si necesitas consulta de proyectos o capacitación, contáctanos en cualquier momento.",
      address: "Dongnam-ro 71-gil, Gangdong-gu, Seúl, Corea del Sur",
      labels: {
        name: "Nombre",
        email: "Correo electrónico",
        message: "Mensaje",
      },
      submit: {
        idle: "Enviar mensaje",
        loading: "Enviando...",
      },
      success: "¡Tu mensaje se envió correctamente!",
      errors: {
        required: "Por favor completa todos los campos.",
        invalidEmail: "Por favor ingresa un correo electrónico válido.",
        submit: "Ocurrió un error al enviar el mensaje.",
        network: "Se produjo un error de red. Inténtalo de nuevo más tarde.",
      },
    },
    footer: {
      rights: "Todos los derechos reservados.",
    },
  },
}

export const getTranslations = (language) =>
  translations[language] || translations[defaultLanguage]

export const getSupportedLanguage = (languageTag) => {
  if (!languageTag || typeof languageTag !== "string") {
    return null
  }

  const normalized = languageTag.toLowerCase()
  const exactMatch = languageOptions.find(({ code }) => code === normalized)
  if (exactMatch) {
    return exactMatch.code
  }

  const baseLanguage = normalized.split(/[-_]/)[0]
  const baseMatch = languageOptions.find(({ code }) => code === baseLanguage)
  return baseMatch ? baseMatch.code : null
}
